// client/src/services/api.js
import axios from 'axios';

const API_URL = 'http://localhost:5000/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add interceptor to include auth token in requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// NFT-related API calls
export const getNFTs = async (filters = {}) => {
  try {
    const response = await api.get('/nfts', { params: filters });
    return response.data;
  } catch (error) {
    console.error('Error fetching NFTs:', error);
    throw error;
  }
};

export const getNFTById = async (id) => {
  try {
    const response = await api.get(`/nfts/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching NFT by ID:', error);
    throw error;
  }
};

// Auth related API calls
export const login = async (credentials) => {
  try {
    const response = await api.post('/auth/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Error during login:', error);
    throw error;
  }
};

export const register = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  } catch (error) {
    console.error('Error during registration:', error);
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

export const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Payment related API calls
export const processPayment = async (paymentDetails, nftDetails) => {
  try {
    const response = await api.post('/payments/process', {
      paymentDetails,
      nftDetails
    });
    return response.data;
  } catch (error) {
    console.error('Payment processing error:', error);
    throw error;
  }
};

export const getUserCollection = async (userId) => {
  try {
    const response = await api.get(`/users/${userId}/collection`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user collection:', error);
    return [];
  }
};

// Export all functions as a default object
export default {
  getNFTs,
  getNFTById,
  login,
  register,
  logout,
  getCurrentUser,
  processPayment,
  getUserCollection
};